module.exports = {
      id: "user-usage",
      viewBox: "0 0 37.689 37.687",
      url: "img/" + "sprite.svg#user-usage",
      toString: function () {
        return this.url;
      }
    }